import { useState, useEffect } from 'react';
import styles from './index.module.sass';
import classnames from 'classnames/bind';
import iconCheck from '../../../../domain/assets/check.svg';
import InfiniteScroll from 'react-infinite-scroll-component';
const cx = classnames.bind(styles);

interface datalistProps {
  data: [];
  selectedKey: string;
  show: boolean;
  onSelect: (key: string) => void;
  withIcon: boolean;
  render: (x: any) => any;
}

const DataList = ({
  data,
  selectedKey = '',
  show,
  onSelect,
  withIcon = true,
  render,
}: datalistProps) => {
  const [currentLength, setCurrentLength] = useState(20);
  const [hasMore, setHasMore] = useState(data.length > 20);
  const [newData, setNewData] = useState([]);

  useEffect(() => {
    setNewData(() => data.slice(0, currentLength));
    setHasMore(data.length > currentLength);
  }, [data]);

  const listClass = cx({
    list: true,
    show,
  });

  const fetchData = () => {
    const isAll = currentLength + 20 > data.length;
    const newLength = isAll ? data.length : currentLength + 20;
    setHasMore(!isAll);
    setCurrentLength(newLength);
    setNewData(() => {
      return data.slice(0, newLength);
    });
  };

  const DataMap = () => {
    if (newData.length === 0) return <div className={styles.empty}>無資料</div>;

    return newData.map(({ key, value }) => {
      const activate = selectedKey === key && key !== 'default';

      const SelectedIcon = () => {
        return activate ? <img src={iconCheck} /> : <></>;
      };

      const itemClass = cx({
        item: true,
        active: activate,
      });

      return (
        <div key={key} className={itemClass} onClick={() => onSelect(key)}>
          {render ? render(value) : <div>{value}</div>}
          {withIcon && <SelectedIcon />}
        </div>
      );
    });
  };

  return (
    <div className={listClass} id="list">
      <InfiniteScroll
        loader=""
        scrollableTarget="list"
        dataLength={currentLength} //This is important field to render the next data
        next={fetchData}
        hasMore={hasMore}
      >
        {DataMap()}
      </InfiniteScroll>
    </div>
  );
};

export default DataList;
